// src/Footer.js
import React from 'react';

const Footer = () => {
  return (
    <footer 
      className="d-flex justify-content-between align-items-center" 
      style={{
        backgroundColor: 'rgba(66, 160, 227, 0.7)',
        padding: '0.5rem 1rem',
        position: 'fixed',
        bottom: 0,
        width: '100%'
      }}
    >
      <p className="mb-0 text-white" style={{ fontWeight: 400, fontSize: '0.875rem' }}>
        © 2025 VB, Inc. All Rights Reserved.
      </p>
      <div className="d-flex align-items-center">
        <a 
          href="https://visbanking.com/contact/" 
          target="_blank" 
          rel="noopener noreferrer"
          className="text-white text-decoration-none mx-2" 
          style={{ fontWeight: 400, fontSize: '0.875rem' }}
        >
          Contact
        </a>
        <a 
          href="https://visbanking.com/pricing/" 
          target="_blank" 
          rel="noopener noreferrer"
          className="text-white text-decoration-none mx-2" 
          style={{ fontWeight: 400, fontSize: '0.875rem' }}
        >
          Pricing
        </a>
        <a 
          href="https://visbanking.com/news-insights/" 
          target="_blank" 
          rel="noopener noreferrer"
          className="text-white text-decoration-none mx-2" 
          style={{ fontWeight: 400, fontSize: '0.875rem' }}
        >
          News &amp; Insights
        </a>
        <a 
          href="https://visbanking.com/disclaimer/" 
          target="_blank" 
          rel="noopener noreferrer"
          className="text-white text-decoration-none mx-2" 
          style={{ fontWeight: 400, fontSize: '0.875rem' }}
        >
          Disclaimer
        </a>
      </div>
    </footer>
  );
};

export default Footer;
